import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./components/authRoutes/PrivateRoutes";
import { auth } from "./firebase";
import { useDispatch } from "react-redux";
import { currentUser } from "./helpers/auth";
import Home from "./screens/Home";
import EventPage from "./screens/EventPage";
import Login from "./screens/auth/Login";
import NotFound from "./components/NotFound";
import Register from "./screens/auth/Register";
import RegisterComplete from "./screens/auth/RegisterComplete";
import Forgot from "./screens/auth/Forgot";
import CreateEvent from "./screens/user/CreateEvent";
import UserHome from "./screens/user/UserHome";
import AdminHome from "./screens/user/AdminHome";
import AdminRoute from "./components/authRoutes/AdminRoute";
import ResetPassword from "./screens/auth/ResetPassword";
import MyEvents from "./screens/user/MyEvents";
import EditEvent from "./screens/user/EditEvent";

export default function Router() {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        currentUser(idTokenResult.token)
          .then((res) =>
            dispatch({
              type: "LOGGED_IN_USER",
              payload: {
                picture: res.data.picture,
                email: res.data.email,
                token: idTokenResult.token,
                role: res.data.role,
                _id: res.data._id,
              },
            })
          )
          .catch((error) => console.error(error));
      }
    });
    return () => unsubscribe;
  }, [dispatch]);

  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/login" exact component={Login} />
      <Route path="/register" exact component={Register} />
      <Route path="/register/complete" exact component={RegisterComplete} />
      <Route path="/forgot/password" exact component={Forgot} />
      <Route path="/event/:id" exact component={EventPage} />
      <PrivateRoute path="/user/dashboard" exact component={UserHome} />
      <PrivateRoute path="/user/password" exact component={ResetPassword} />
      <PrivateRoute path="/user/events" exact component={MyEvents} />
      <AdminRoute path="/admin/dashboard" exact component={AdminHome} />
      <PrivateRoute path="/create" exact component={CreateEvent} />
      <PrivateRoute path="/edit/:id" exact component={EditEvent} />
      <Route component={NotFound} />
    </Switch>
  );
}
